import { TextDangerStyled } from './TextDanger.styled'

export const TextDanger = ({ children }) => {
  return <TextDangerStyled className="text-danger">{children}</TextDangerStyled>
}
